import React from "react";
import { motion } from "framer-motion";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    button: {
        outline: 'none',
        border: 'none',
        webkitUserSelect: 'none',
        mozUserSelect: 'none',
        msUserSelect: 'none',
        cursor: 'pointer',
        position: 'absolute',
        top: '18px',
        left: '15px',
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        background: 'transparent',
      }
});

const Path = props => (
  <motion.path
    fill="transparent"
    strokeWidth="3"
    stroke={props.dark? '#fff': "hsl(0, 0%, 18%)"}
    strokeLinecap="round"
    {...props}
  />
);

const MenuToggle = ({ toggle, dark }) => {
    const classes = useStyles();
    
    return (
        <button onClick={toggle} className={classes.button}>
            <svg width="23" height="23" viewBox="0 0 23 23">
                <Path
                    variants={{
                        closed: { d: "M 2 2.5 L 20 2.5" },
                        open: { d: "M 3 16.5 L 17 2.5" }
                    }}
                    dark={dark}
                />
                <Path
                    d="M 2 9.423 L 20 9.423"
                    variants={{
                        closed: { opacity: 1 },
                        open: { opacity: 0 }
                    }}
                    dark={dark}
                    transition={{ duration: 0.1 }}
                />
                <Path
                    variants={{
                        closed: { d: "M 2 16.346 L 20 16.346" },
                        open: { d: "M 3 2.5 L 17 16.346" }
                    }}
                    dark={dark}
                />
            </svg>
        </button>
    )};

export default MenuToggle;